import { Box, Button, HStack, Spinner, Text } from '@chakra-ui/react';
import { Icon } from '@blueprintjs/core';
import { useContext, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import * as turf from '@turf/turf';
import UIContext from '../../context/UIContext';

function computeRouteDistanceMeters(coordinates) {
    if (!coordinates || coordinates.length < 2) {
        return 0;
    }
    const line = turf.lineString(coordinates);
    return turf.length(line, { units: 'meters' });
}

function formatDistanceMeters(meters) {
    if (meters >= 1000) {
        return (meters / 1000).toFixed(2) + ' km';
    }
    if (meters >= 10) {
        return meters.toFixed(1) + ' m';
    }
    if (meters >= 1) {
        return meters.toFixed(2) + ' m';
    }
    return meters.toFixed(3) + ' m';
}

export default function RoutingDisplay() {
    const history = useHistory();
    const { routeResults, routeInputWaypoints, setRouteInputWaypoints, setRouteResults } = useContext(UIContext);

    let routingState = 'pending';
    if (routeResults?.success) {
        routingState = 'success';
    }
    if (routeResults && routeResults.success == false) {
        routingState = 'failure';
    }
    if (routeInputWaypoints.length < 2) {
        routingState = 'idle';
    }

    const distanceText = useMemo(() => {
        if (routeResults?.route?.length > 1) {
            const routeCoordinates = routeResults.route.map((waypoint) => [waypoint[1], waypoint[0]]);
            return formatDistanceMeters(computeRouteDistanceMeters(routeCoordinates));
        }
        if (routeInputWaypoints.length > 1) {
            const waypointCoordinates = routeInputWaypoints.map((waypoint) => [waypoint.longitude, waypoint.latitude]);
            return formatDistanceMeters(computeRouteDistanceMeters(waypointCoordinates));
        }
        return '0.000 m';
    }, [routeResults, routeInputWaypoints]);

    const routePointCountText = `${routeInputWaypoints.length} point${routeInputWaypoints.length != 1 ? 's' : ''}`;

    return (
        <Box
            pointerEvents="auto"
            zIndex={20}
            display="flex"
            flexDir="column"
            justifyContent="stretch"
            alignItems="stretch"
            bg="rgba(255,255,255,0.9)"
            borderRadius="4px"
            border="1px solid rgba(0,0,0,0.1)"
            shadow="md"
            padding="0px"
            overflow="hidden"
            boxShadow={'0px 0px 0px 2px rgba(0,0,0,0.1)'}
            position="relative"
            minW="450px"
        >
            <HStack spacing={1} p="8px">
                <Text fontWeight="500">Routing Tool</Text>
            </HStack>
            <Box
                bg="rgba(0,0,0,0.05)"
                w="100%"
                borderTop="1px solid rgba(0,0,0,0.1)"
                p="6px 8px"
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
                minH="40px"
                maxH="40px"
            >
                <Text flex="0 0 auto" mr="10px" fontFamily="monospace" fontWeight="600" fontSize="14px">
                    {distanceText}
                </Text>
                <Text flex="0 0 auto" fontFamily="monospace" fontWeight="600" fontSize="14px" opacity="0.6">
                    ({routePointCountText})
                </Text>
                <Box flex="1" />
                <Button
                    size="sm"
                    variant="ghost"
                    onClick={() => history.push('/routes' + history.location.search)}
                >
                    <Icon icon="cog" />
                    <Text ml="6px">Edit Settings</Text>
                </Button>
            </Box>
            {/* <Box
                w="100%"
                borderTop="1px solid rgba(0,0,0,0.1)"
                p="6px 8px"
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
                bg={routingState == 'failure' ? '#ffefef' : 'white'}
            >
                {routingState == 'pending' && (
                    <HStack>
                        <Spinner speed="2s" color="blue.500" thickness="3px" />
                        <Text color="blue.500" fontWeight="600">Routing in Progress...</Text>
                    </HStack>
                )}
                {routingState == 'success' && (
                    <HStack>
                        <Text color="green.500"><Icon icon="tick" size={16} /></Text>
                        <Text color="green.500" fontWeight="600">Routing Completed</Text>
                    </HStack>
                )}
                {routingState == 'failure' && (
                    <HStack>
                        <Text color="red.500"><Icon icon="cross" size={16} /></Text>
                        <Text color="red.500" fontWeight="600">Routing Failed</Text>
                    </HStack>
                )}
                {routingState == 'idle' && <Box h="20px" />}
            </Box> */}
            <Button
                _hover={{
                    color: 'rgba(0,0,0,1.0)',
                }}
                bg={''}
                w="40px"
                h={'40px'}
                position="absolute"
                top="0px"
                right="0px"
                onClick={() => {
                    setRouteInputWaypoints([]);
                    setRouteResults({
                        loading: false,
                        success: false,
                        route: [],
                        messages: [{
                            message: 'Not enough points to route. Please add 2 or more points!'
                        }]
                    });
                    history.push('/' + history.location.search);
                }}
                color={'rgba(0,0,0,0.8)'}
            >
                <Text mb="0px">
                    <Icon icon={'cross'} size="16" />
                </Text>
            </Button>
        </Box>
    );
}
